<template>
    <div class="p-3">
        <h3>RL 3.4 Rekapitulasi Jenis Pengunjung</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Rekapitulasi Jenis Pengunjung" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/jenis-pengunjung',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columns: [
                    {
                        title: "Jenis Pengunjung",
                        field: "jenis_kunjungan",
                    },
                    {
                        title: "Jumlah",
                        field: "jumlah_kunjungan",
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
